import type { ComponentPropsWithRef } from "react";
import { styled } from "styled-components";

import { breakpoints } from "common/styles";

export const UIButtonsRow = (props: ComponentPropsWithRef<"div">) => <StyledUIButtonsRow {...props} />;

const StyledUIButtonsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0 30px;

  @media ${breakpoints.medium} {
    gap: 0 10px;
  }
  @media ${breakpoints.large} {
    gap: 0 30px;
  }
`;
